module.exports = __webpack_public_path__ + "img/unlink5.0fe6c18c.png";